import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IInventoryDetailsResponse, IInventoryDetailsResponseData } from "@/api_framework/api_modals/Inventory";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "../../useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useInventoryVendorGetDetailsAPI = () => {
  const [vendorDetails, setVendorDetails] = useState<IInventoryDetailsResponseData>(null);
  const dispatch = useAppDispatch();
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();
  const execute = useCallback(
    async (vendorId: string) => {
      dispatch(
        setLoading({
          key: "isInventoryVendorListLoadingInProgess",
          status: true,
        }),
      );

      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        await axios
          .get(`${INVENTORY_MODULE?.VENDOR_DETAILS?.baseURL}${vendorId}/`, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IInventoryDetailsResponse>) => {
            dispatch(
              setLoading({
                key: "isInventoryVendorListLoadingInProgess",
                status: false,
              }),
            );
            if (res.data.status === true) {
              setVendorDetails(res.data.data);
            } else {
              setVendorDetails(null);
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            setVendorDetails(null);
            dispatch(
              setLoading({
                key: "isInventoryVendorListLoadingInProgess",
                status: false,
              }),
            );

            captureError(e)
          });
      } catch (e: any) {
        toast.error("Server Error: " + e.message);
      }
    },
    [dispatch],
  );
  return { vendorDetails, execute };
};
